import { render, staticRenderFns } from "./InvalidAccount.vue?vue&type=template&id=78747fde"
import script from "./InvalidAccount.vue?vue&type=script&lang=ts"
export * from "./InvalidAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports